import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class EquipmentGroupsApi extends ApiModule {
	constructor() {
		super(ModulesMap.EQUIPMENT_GROUPS, {
			entity: 'equipment_groups',
		})
	}
}
